import { render, staticRenderFns } from "./ChartConfigForm.vue?vue&type=template&id=34c73a72"
import script from "./ChartConfigForm.vue?vue&type=script&lang=js"
export * from "./ChartConfigForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports